import React, {Component} from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import DesktopWindowsIcon from '@material-ui/icons/DesktopWindows';
//import BGImage from '../../../Utilities/default.jpg'
import CompositionContainer from './EditContent/EventEditComponet/CompositionContainer'
import ContainerGroup from './EditContent/EventEditComponet/ContainerGroup'
import UpBanner from '../../TempWebPage/UpBanner/UpBanner'


const wStyles = theme => ({
    textLinkPreviewRight:{
        float:"right",
        height:40,
        color:"#808080",
        fontFamily:"Microsoft JhengHei",
        borderStyle:"soild",
        borderWidth:1,
        borderColor:"#333333",
        backgroundColor:"#333333",
        textAlign:"center",
        fontSize:20,
        lineHeight:"30px",
        margin:5,
        '&:hover':{
            color:"white",
            backgroundColor:"#2783c4",
            borderColor:"white",
        },
    },
})

class ContentPreview extends Component {
    constructor(props) {
        super(props)
        this.state = {
            windowSize:"large"
        }
        this.openTempFile = React.createRef()
        this.scrollContainerLayout = React.createRef()   
    }

    componentDidMount(){
        window.addEventListener("resize", this.getResizeWidth)
    }

    componentDidUpdate(){
   
    }

    componentWillUnmount(){

    }

    getResizeWidth=()=>{
        //console.log(this.scrollContainerLayout)
        let tempWidth = 1900
        if(this.scrollContainerLayout.current)
        {
            tempWidth = this.scrollContainerLayout.current.scrollWidth
        }
    
        //console.log(tempWidth)
        if(tempWidth >= 1900)
        {
            if(this.state.windowSize !== "large")
            {
                this.setState({
                    windowSize :"large"
                })
            }
        }
        else if(tempWidth<1900 && tempWidth >= 1300)
        {
            if(this.state.windowSize !== "medium")
            {
                this.setState({
                    windowSize :"medium"
                })
            }
        }
        else if(tempWidth<1300)
        {
            if(this.state.windowSize !== "small")
            {
                this.setState({
                    windowSize :"small"
                })
            }
        }
    }

    createContainer=()=>{
        if(this.state.windowSize === "large")
        {
            return this.renderInLargeContainer()
        }
        else if(this.state.windowSize === "medium")
        {
            return this.renderInMediumContainer()
        }
        else if(this.state.windowSize === "small")
        {
            return this.renderInMediumContainer()
        }

        //console.log("ContentPreview createContainer...")
    }

    renderInLargeContainer=()=>{
        if(this.props.compositionContainers && this.props.bodySize)
        {
            return(
                this.props.compositionContainers.map(container=>{

                    let pos2 = {
                        x:(container.x/this.props.bodySize.width)*100+"%",
                        y:container.y
                    }
            
                    let size = {
                        width:(container.width/this.props.bodySize.width)*100+"vw",
                        height:container.height
                    }

                    return(
                        <CompositionContainer key={container.conID} conID={container.conID} type={container.type} previewMode={true} bodySize={this.props.bodySize} commonAttributes={container.commonAttributes} imageAttributes={container.imageAttributes} textAttributes={container.textAttributes} color={"grey"} divPos={pos2}  size={size} />
                    )
                })
            )
        }
        else
        {
            return null
        }
    }

    renderInMediumContainer=()=>{
        if(this.props.compositionContainers)
        {
            /// sorting array
            let tempArray = this.props.compositionContainers.map(composition=>{
                return composition
            }).sort((a,b)=>{
                return a.y-b.y
            })

            console.log("sorting array :")
            console.log(tempArray)

            let groupArray = []
            let groupObj = []
            //let prevMinHeight=0
            let prevMaxHeight=0 
            //let groupToken = false

            for(var i =0; i<tempArray.length; i++)
            {
                //console.log("loop i : ", i)
                if(i === 0)
                {      
                    groupObj.push(tempArray[i]) 
                }
                else if(i === tempArray.length-1)
                {
                    prevMaxHeight = tempArray[i-1].y+tempArray[i-1].height
                    if(tempArray[i].y < prevMaxHeight)
                    {
                        //console.log("height been involved : ", i-1, i)
                        groupObj.push(tempArray[i])
                        let tempGroupObj = groupObj.map(obj=>{
                            return obj
                        })
                        groupArray.push(tempGroupObj )
                    }
                    else
                    {
                        let tempGroupObj = groupObj.map(obj=>{
                            return obj
                        })
                        groupArray.push(tempGroupObj)
                        let finalGroupObj = []
                        finalGroupObj.push(tempArray[i])
                        groupArray.push(finalGroupObj)
                    }
                }
                else
                {
                    ///prevMinHeight = tempArray[i-1].y
                    prevMaxHeight = tempArray[i-1].y+tempArray[i-1].height
                    if(tempArray[i].y < prevMaxHeight)
                    {
                        //console.log("height been involved : ", i-1, i)
                        groupObj.push(tempArray[i])
                    }
                    else
                    {
                        let tempGroupObj = groupObj.map(obj=>{
                            return obj
                        })
                        groupArray.push(tempGroupObj)
                        groupObj = []
                        groupObj.push(tempArray[i])
                    }
                }
            }

            console.log("groupArray :")
            console.log(groupArray)

            let finalGroupArray =[]

            groupArray.forEach(array=>{
                if(array.length>1)
                {
                    let minY = Math.min.apply(Math, array.map(container=>{return container.y}))
                    //let maxY = Math.max.apply(Math, array.map(container=>{return container.y+container.height}))
                    //let maxHeight = maxY-minY
                    let newArray = array.map(container=>{
                        let tempContainer = {
                            conID:container.conID,
                            width:container.width,
                            height:container.height,
                            x:container.x,
                            y:container.y-minY,
                            imageAttributes:container.imageAttributes,
                            textAttributes:container.textAttributes,
                            title:container.title,
                            type:container.type,
                            zIndex:container.zIndex
                        }
                        return tempContainer
                    })
                    finalGroupArray.push(newArray)
                }
                else
                {
                    finalGroupArray.push(array)
                }
            })

            console.log("finalGroupArray :")
            console.log(finalGroupArray)


            return(
                finalGroupArray.map((array,index)=>{
                console.log("A1")
                return (
                    <ContainerGroup key={index} indexKey={index} containerArray={array} bodySize={this.props.bodySize} previewSize={this.state.windowSize}/>
                )
            })
            )

        }
        else
        {
            return null
        }
    }
    
    render(){
        const {classes} = this.props;


        let scrollContainer={
            position:"fixed",
            top:0,
            left:0,
            width:"100vw",
            height:"100vh",
            backgroundColor:"#ffffff",
            overflow:"scroll",
            zIndex:1400
        }

        let middleLayout = {
            position:this.state.windowSize === "small"? "sticky":"relative",
            top:0,
            marginLeft:"auto",
            marginRight:"auto",
            borderRadius:"10px",
            width:"90vw",
            height:this.state.windowSize === "small"? "100vh" : this.props.bodyHeight,
            //height:"1300px",
            backgroundColor:"#ffffff",
            opacity:"0.3"
        }

        let backgroundImageStyle = {
            //backgroundImage: `url(${BGImage})`,
            backgroundRepeat: "no-repeat",
            backgroundAttachment: "fixed",
            backgroundPosition: "center",
            backgroundSize: "cover",
            position:"fixed",
            top:0,
            left:0,
            width:"100vw",
            height:"100vh",
            filter:"blur(5px)"
        }

        return (

            <div style={scrollContainer}  ref={this.scrollContainerLayout} >
                <div style={backgroundImageStyle}/>
                <UpBanner previewMode={true}> 
                    <Button className={classes.textLinkPreviewRight} startIcon={<DesktopWindowsIcon />} onClick={()=>this.props.previewToggle()}>
                        結束預覽
                    </Button> 
                </UpBanner>
                <div style={middleLayout}/> 
                {this.createContainer()}
            </div>
           
        )  
    }
}

export default withStyles(wStyles)(ContentPreview)
